const FeatureKeys = {
  Messaging: 'MESSAGING',
  Surveys: 'SURVEYS',
};

export default FeatureKeys;
